export const /** AI Provider names */ AI_PROVIDER_NAMES = {
    ANTHROPIC: 'Anthropic',
    KIMI: 'Kimi',
    OPENAI: 'OpenAI',
    WEB_ACCESS: 'Web Access',
    X: 'xAI',
    GOOGLE: 'Google',
    DEEPSEEK: 'DeepSeek',
    MISTRALAI: 'Mistral AI',
    INCOGNITO: 'Incognito',
};
